import React, { useMemo } from "react";
import {
  createFilteredAndSortedOptions,
  createFilteredAndSortedUniqueOptions,
} from "../../../util/dealingArrObj";
import { useTranslation } from "react-i18next";

export default function DropdownsToFilter({
  schoolYear,
  schoolYearId,
  schoolStageId,
  handleDropdownChange,
  user,
  settingData,
  rows,
  selectedUser,
  activeMenu,
  termPeriodData,
  selectedTerm,
}) {
  const { t } = useTranslation();
  const optionTeacherDropdown =
    activeMenu?.options?.[0]?.[activeMenu?.schoolid]?.teacherDropdown ?? true;

  const optionTermName =
    activeMenu?.options?.[0]?.[activeMenu?.schoolid]?.termName || "";

  const { arrayData, displayKey, valueKey, filters, idKey, sortKey, isDesc } = {
    arrayData: settingData,
    displayKey: "school_year",
    valueKey: "id",
    filters: { hierarchy_level: 0, parent_id: 0 },
    idKey: "id",
    sortKey: "school_year",
    isDesc: true,
  };

  const options = useMemo(() => {
    return createFilteredAndSortedOptions({
      arrayData,
      displayKey,
      valueKey,
      filters,
      idKey,
      sortKey,
      isDesc,
    });
  }, [arrayData, displayKey, valueKey, filters, idKey, sortKey, isDesc]);

  const optionsOne = useMemo(() => {
    return createFilteredAndSortedOptions({
      arrayData,
      displayKey: "group_name",
      valueKey,
      filters: { hierarchy_level: 1, school_year: schoolYear },
      idKey,
      sortKey: "order",
      isDesc: false,
      dataName: "organization_path",
    });
  }, [arrayData, valueKey, idKey, schoolYear]);

  const optionsUser = useMemo(() => {
    return createFilteredAndSortedUniqueOptions({
      arrayData: rows,
      displayKey: "fullname",
      valueKey: "creator_username",
      filters: { school_year: schoolYear },
      uniqueKey: "creator_username",
      sortKey: "fullname",
      isDesc: false,
    });
  }, [rows, schoolYear]);

  // console.log("termPeriodData", termPeriodData);

  return (
    <div className="d-flex gap-2 align-items-center">
      <select
        className="form-control"
        name="0"
        onChange={handleDropdownChange}
        value={schoolYearId || ""}
      >
        {settingData?.length > 0 && options}
        <option value="all">{t("common.labels.all")}</option>
      </select>
      <select
        className="form-control"
        name="1"
        onChange={handleDropdownChange}
        value={schoolStageId || ""}
      >
        <option value="">
          {t("common.labels.selectSchoolStage") || "과정선택"}
        </option>
        {settingData?.length > 0 && optionsOne}
        <option value="0">{t("common.labels.whole") || "통합"}</option>
      </select>

      {optionTeacherDropdown && (
        <select
          className="form-control"
          name="users"
          onChange={handleDropdownChange}
          value={selectedUser || ""}
        >
          <option value="">{t("common.user.teacher")}</option>
          {/* <option value={user?.username}>{user?.fullname}</option> */}
          {rows?.length > 0 && optionsUser}
        </select>
      )}

      {optionTermName && (
        <select
          className="form-control"
          name="termName"
          onChange={handleDropdownChange}
          value={selectedTerm || ""}
        >
          {termPeriodData &&
            Array.from(
              new Map(
                termPeriodData.map((item) => [item.term_name, item]),
              ).values(),
            )
              .sort((a, b) => a.term_name.localeCompare(b.term_name))
              .map((r) => (
                <option key={r.term_name} value={r.term_name}>
                  {r.term_name}
                  {t("common.labels.termName")}
                </option>
              ))}
        </select>
      )}
    </div>
  );
}
